export const TEAM_OWNER = 'TeamOwner'
export const TEAM_MEMBER = 'TeamMember'
export const ADMIN = 'Admin'
export const ARBITRATOR = 'Arbitrator'
export const SCORER = 'Scorer'
